var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = !(_vm.currentTab === "apply")
    ? _vm.__map(_vm.historyList, function (item, __i1__) {
        var $orig = _vm.__get_orig(item)
        var g0 = item.actions && item.actions.length
        return {
          $orig: $orig,
          g0: g0,
        }
      })
    : null
  var l1 = _vm.__map(_vm.tabs, function (tab, __i3__) {
    var $orig = _vm.__get_orig(tab)
    var m0 = _vm.getTabIcon(tab)
    var m1 = m0 ? _vm.getTabIcon(tab) : null
    return {
      $orig: $orig,
      m0: m0,
      m1: m1,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.email = ""
    }
    _vm.e1 = function ($event, tab) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        tab = _temp2.tab
      var _temp, _temp2
      _vm.currentTab = tab.value
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }